import { render, staticRenderFns } from "./GreetJob.vue?vue&type=template&id=a2b3b6e0&scoped=true"
import script from "./GreetJob.vue?vue&type=script&lang=js"
export * from "./GreetJob.vue?vue&type=script&lang=js"
import style0 from "./GreetJob.vue?vue&type=style&index=0&id=a2b3b6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b3b6e0",
  null
  
)

export default component.exports